import { render, staticRenderFns } from "./ManageAudits.vue?vue&type=template&id=4a15b921&scoped=true&"
import script from "./ManageAudits.vue?vue&type=script&lang=js&"
export * from "./ManageAudits.vue?vue&type=script&lang=js&"
import style0 from "./ManageAudits.vue?vue&type=style&index=0&id=4a15b921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15b921",
  null
  
)

export default component.exports